import React from 'react';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';

import { WizardStep } from 'ui/components/Wizard/types';

export const getCreatePurchaseOrderWizardSteps = (
  activeStep: number
): WizardStep[] => {
  return [
    {
      label: 'Step 1',
      icon:
        activeStep > 0 ? (
          <RadioButtonCheckedIcon />
        ) : (
          <RadioButtonUncheckedOutlinedIcon />
        ),
    },
    {
      label: 'Step 2',
      icon:
        activeStep > 1 ? (
          <RadioButtonCheckedIcon />
        ) : (
          <RadioButtonUncheckedOutlinedIcon />
        ),
    },
  ];
};
